import React, { ReactElement } from 'react'
import type { KioskCollectTodayState } from './types/KioskCollectToday'

type KioskCollectTodayDateOptionProps = {
  state: KioskCollectTodayState;
  onSelect: () => void;
}

const KioskCollectTodayDateOption = ({
  state, onSelect
}: KioskCollectTodayDateOptionProps): ReactElement | null => {
  if (state.available) {
    return (
      <div className="kioskCollectToday">
        <button
          type="button"
          className={`kioskCollectToday-option ${state.selected ? 'selected' : ''}`}
          aria-pressed={state.selected}
          onClick={onSelect}
        >
          <strong className="kioskCollectToday-title">Collect Today</strong>
          <span className="kioskCollectToday-copy">Collect today. Our team will start preparing it as soon as you check out.</span>
        </button>
      </div>
    )
  }

  return (
    <div className="kioskCollectToday">
      <div className="kioskCollectToday-unavailable">
        <strong className="kioskCollectToday-title">Collect Today Unavailable</strong>
        <span className="kioskCollectToday-copy">This basket isn&apos;t eligible for same-day collection. Please choose another collection date.</span>
      </div>
    </div>
  )
}

export default KioskCollectTodayDateOption
